angular
    .module("lodgeClaim.controller", ['ui.mask'])
    .controller('lodgeClaimController', ['$rootScope', '$scope', '$timeout', '$filter', '$window', 'popupService', 'commonConst', 'highlighter', 'lodgeClaimWording', 'lodgeClaimConst', 'jurisdictionEnum', 'uploadFileWording', 'lodgeClaimService', 'commonService', 'httpService',
        function ($rootScope, $scope, $timeout, $filter, $window, popupService, commonConst, highlighter, lodgeClaimWording, lodgeClaimConst, jurisdictionEnum, uploadFileWording, lodgeClaimService, commonService, httpService) {
            UploadFileExtension($scope, {
                // $form: document.querySelector('#fileupload'),
                submitText: 'Submit',
                fnFileUploadAdd: fnFileUploadAdd,
                fnFileUploadStop: fnFileUploadStop,
                fnFormValidation: fnFormValidation,
            }, uploadFileWording, $window, httpService);

            $scope.pageName = 'Lodge a Claim';
            $scope.pageBreadcrumbs = [{
                url: '/',
                title: 'Home'
            }, {
                url: null,
                title: 'Lodge a Claim'
            }];

            $scope.pageForms = {};
            $scope.baseUploadPath = 'uploads';
            $scope.jurisdictionEnum = jurisdictionEnum;
            $scope.selectedJurisdiction = $rootScope.getSelectedJurisdiction();
            $scope.chkJurisdiction = $scope.selectedJurisdiction;
            $scope.fileData = null;
            $scope.isLogin = true;
            $scope.iCareLodgeClaimUrl = lodgeClaimConst.ICARE_LODGE_CLAIM_URL;
            $scope.selectedData = {
                policy: null
            };
            $scope.formData = {
                policyId: null,
                uploadSession: $scope.generateUploadSession(),
                description: $scope.typeValue,
                workerName: '',
                address: '',
                dateOfBirth: '',
                phoneNumber: ''
            }

            if ($scope.selectedJurisdiction === jurisdictionEnum.NSW) {
                commonService.openLink($scope.iCareLodgeClaimUrl);
            }

            $scope.selectJurisdiction = function (jurisdiction) {
                $scope.chkJurisdiction = jurisdiction;
                if (jurisdiction === jurisdictionEnum.NSW.toString()) {
                    commonService.openLink($scope.iCareLodgeClaimUrl);
                }

            } // selectJurisdiction

            $scope.$on('policySelectionChanged', function (event, policy) {
                $scope.$broadcast('reloadLodgeClaimHistoryHistory', {
                    policyId: policy ? policy.EmployerId : null
                });
            }); // policySelectionChanged

            $scope.submitLodgeClaim = function () {
                lodgeClaimService.saveLodgeClaimInfo({
                    UploadSession: $scope.formData.uploadSession,
                    EmployerId: $scope.formData.policyId,
                    WorkerName: $scope.formData.workerName,
                    Comment: $scope.formData.comment,
                    PhoneNumber: $scope.formData.phoneNumber,
                    Address: $scope.formData.address,
                    DateOfBirth: $scope.formData.dateOfBirth,
                    DocumentType: $scope.formData.description,
                    UploadUserId: $filter('decstr64')(sessionStorage.UserId)

                }).then(function (response) {
                    if (response.Success) {
                        sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                        sessionStorage.Policy = $filter('enstr64')(JSON.stringify($scope.selectedData.policy));
                        $scope.$broadcast('clearDropdownCache');

                        popupService.showMultiActionDialog(
                            lodgeClaimWording.LODGE_CLAIM_SUCCESS,
                            undefined, [{
                                    text: 'Done',
                                    buttonClass: 'button-primary',
                                    actionCallback: function () {
                                        $window.location = "/";
                                    },

                                },
                                {
                                    text: 'Lodge New Claim',
                                    buttonClass: 'button-primary',
                                    actionCallback: $scope.logdeAnotherClaim,
                                }
                            ]);

                    } else if (angular.isDefined(response.ErrorMessage)) {
                        $scope.setError(response.ErrorMessage);
                        popupService.showError(response.ErrorMessage);

                    } else {
                        var uploadError = $scope.getFileUploadError();
                        popupService.showValidationServerErrors(uploadError);
                    }

                    //After submit need to get recent policies from rootscope
                    $rootScope.getRecentPoliciesAndClaims();
                })
            } // submitLodgeClaim

            $scope.removeFile = function (file, queue) {
                event.stopPropagation();
                event.preventDefault();
                $scope.deleteFileUpload(file);
                file.$cancel();
                if (queue.length == 0) {
                    $scope.clearError();
                    $scope.uploadControl.allowSubmit = false;
                }
                if (!$scope.isClaimFormAttached())
                    $scope.medicalFileName = '';
            } // removeFile
            $scope.aClicked = false;
            $scope.selectFiles = function (f, selectClaimForm) {
                $timeout(function () {
                    if (!$scope.aClicked) {
                        var $file = angular.element(f);
                        if (selectClaimForm) {
                            if ($scope.isClaimFormAttached()) {
                                popupService.showExternalError(lodgeClaimWording.VALIDATION_CLAIM_FORM_EXIST, $scope.isLogin);
                                return;
                            }
                            $file.removeAttr('multiple')
                            $scope.medicalFileType = lodgeClaimWording.WORKER_CLAIM_FORM;
                        } else {
                            $file.attr('multiple', 'multiple');
                            $scope.medicalFileType = lodgeClaimWording.ADDITIONAL_DOCUMENT;
                        }
                        $timeout(function () {
                            $file.trigger('click');
                        }, 100);
                    }

                    $scope.aClicked = false;
                }, 0)
            } // selectFiles
            $('body').on('click', '.upload-file', function () {
                $scope.aClicked = true;
            })
            $scope.logdeAnotherClaim = function () {
                $scope.resetForm();
                $(window).scrollTop(0);
            }


            $scope.resetForm = function (isResetPolicy) {
                if (isResetPolicy) {
                    $scope.$broadcast('resetPolicySelection');
                }
                //clean up input 
                $scope.formData.workerName = '';
                $scope.formData.address = '';
                $scope.formData.dateOfBirth = '';
                $scope.formData.phoneNumber = '';
                $scope.formData.comment = '';
                $scope.formData.uploadSession = $scope.generateUploadSession();
                //reset upload file
                $scope.uploadControl.totalSize = 0;
                $scope.uploadControl.allowSubmit = false;
                $scope.uploadControl.allowAddFile = true;
                $scope.uploadControl.submitText = 'Submit';
                $scope.medicalFileName = '';
                if ($scope.fileData) {
                    // must in timeout because IE cause some strange bug...
                    $timeout(function () {
                        $scope.fileData.scope.queue.length = 0;
                    });
                }

                $scope.clearError();
                $scope.pageForms.claimForm.$setPristine();
                $scope.pageForms.claimForm.$setUntouched();

                //reload history
                $scope.$broadcast('reloadLodgeClaimHistoryHistory', {
                    policyId: $scope.formData.policyId
                });

                popupService.hide();
            } // resetForm

            $scope.checkPossibleBirthday = function () {
                setTimeout(function () {
                    var birthday = $scope.formData.dateOfBirth;
                    if (!isValidDateTimeFormat(birthday))
                        return;
                    var age = moment().year() - moment(birthday, commonConst.DATE_FORMAT, true).year();
                    if (age < 13 || age > 100) {
                        popupService.showExternalError(lodgeClaimWording.VALIDATION_INVALID_DOB, $scope.IsLogin);
                    }
                }, 100);
            }; // checkPossibleBirthday


            function fnFileUploadAdd(e, data) {
                if (data.files.length == 0)
                    return;
                data.files.forEach(function (file, index) {
                    if (!angular.isDefined(file.error)) {
                        if (!$scope.isClaimFormAttached())
                            file.medicalFileType = lodgeClaimWording.WORKER_CLAIM_FORM;
                    }
                });
                $scope.fileData = data;
                $scope.uploadControl.allowSubmit = data.scope.queue.length > 0;
            }; // fnFileUploadAdd

            function fnFileUploadStop(e) {
                if ($scope.uploadResult.hasError) {
                    var uploadError = $scope.getFileUploadError();
                    popupService.showValidationServerErrors(uploadError);

                } else {
                    $scope.submitLodgeClaim();
                }
            }; // fnFileUploadStop

            // BEGIN validation section

            function fnFormValidation() {
                var fields = [{
                        formProp: 'policyId',
                        htmlId: 'policy-id',
                        message: lodgeClaimWording.VALIDATION_POLICY_REQUIRED
                    },
                    {
                        formProp: 'workerName',
                        htmlId: 'worker-name',
                        message: lodgeClaimWording.VALIDATION_WORKER_NAME_REQUIRED
                    },
                    {
                        fnValidation: isValidWorkerName,
                        formProp: 'workerName',
                        htmlId: 'worker-name',
                        message: lodgeClaimWording.VALIDATION_INVALID_WORKER_NAME
                    },
                    {
                        formProp: 'address',
                        htmlId: 'address',
                        message: lodgeClaimWording.VALIDATION_ADDRESS_REQUIRED
                    },
                    {
                        formProp: 'dateOfBirth',
                        htmlId: 'dob',
                        message: lodgeClaimWording.VALIDATION_DOB_REQUIRED
                    },
                    {
                        fnValidation: isValidDateTimeFormat,
                        formProp: 'dateOfBirth',
                        htmlId: 'dob',
                        message: lodgeClaimWording.VALIDATION_INVALID_DOB
                    },
                    {
                        formProp: 'phoneNumber',
                        htmlId: 'phone-number',
                        message: lodgeClaimWording.VALIDATION_PHONE_REQUIRED
                    },
                    {
                        fnValidation: isAUPhoneNumber,
                        formProp: 'phoneNumber',
                        htmlId: 'phone-number',
                        message: lodgeClaimWording.VALIDATION_INVALID_PHONE
                    },
                    {
                        fnValidation: $scope.isClaimFormAttached,
                        message: lodgeClaimWording.VALIDATION_CLAIM_FORM_REQUIRED
                    }
                ];

                for (var i = 0; i < fields.length; i++) {
                    if (!validateField(fields[i])) {
                        return false;
                    }
                }

                return true;
            }

            function validateField(field) {
                if (!field) return false;
                if ((angular.isFunction(field.fnValidation) && !field.fnValidation($scope.formData[field.formProp])) ||
                    (field.formProp && !$scope.formData[field.formProp])) {
                    if (field.htmlId) highlighter.highlightFields(field.htmlId);
                    if (field.message) popupService.showExternalError(field.message, $scope.isLogin);
                    return false;
                }

                return true;
            }

            function isAUPhoneNumber(phoneNumber) { //both phone and mobile
                if (phoneNumber === '')
                    return true;

                //var mobilePhoneRegex = /^(?:\+?61|0)4 ?(?:(?:[01] ?[0-9]|2 ?[0-57-9]|3 ?[1-9]|4 ?[7-9]|5 ?[018]) ?[0-9]|3 ?0 ?[0-5])(?: ?[0-9]){5}$/;
                //var mobilePhoneRegex = /^\({0,1}((0|\+61)(2|4|3|7|8|5)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/
                var mobilePhoneRegex = /^\d{10}$/;
                return mobilePhoneRegex.test(phoneNumber);
            }

            function isValidWorkerName(name) {
                if (name === '')
                    return true;

                var workerNameRegex = /^([A-Za-z0-9]|\'|\-| )+$/;
                return workerNameRegex.test(name);
            }

            function isValidDateTimeFormat(date, isDateHourFormat) {
                var isValid = true;
                var format = commonConst.DATE_FORMAT;
                if (!!isDateHourFormat) {
                    format = commonConst.DATETIME_FORMAT;
                }
                if (!moment(date, format, true).isValid()) {
                    isValid = false;
                }
                return isValid;
            };

            $scope.isClaimFormAttached = function () {
                if ($scope.fileData == null || $scope.fileData.scope == null || $scope.fileData.scope.queue.length == 0)
                    return false;
                var files = $scope.fileData.scope.queue;
                var result = files.some(function (file) {
                    var medicalFileType = file.medicalFileType || '';
                    return medicalFileType == lodgeClaimWording.WORKER_CLAIM_FORM;
                });
                return result;
            }

            $scope.listAdditionDocument = function () {
                if ($scope.fileData == null || $scope.fileData.scope == null || $scope.fileData.scope.queue.length == 0)
                    return null;
                var files = $scope.fileData.scope.queue;
                return files.filter(function (item) {
                    return item.medicalFileType !== lodgeClaimWording.WORKER_CLAIM_FORM
                });
            }

            $scope.workerClaimForm = function () {
                if ($scope.fileData == null || $scope.fileData.scope == null || $scope.fileData.scope.queue.length == 0)
                    return null;
                var files = $scope.fileData.scope.queue;
                return files.filter(function (item) {
                    return item.medicalFileType === lodgeClaimWording.WORKER_CLAIM_FORM
                });
            }

            // END validation section
        }
    ]);